import { render, staticRenderFns } from "./recover_dialog.vue?vue&type=template&id=2205c272&scoped=true"
import script from "./recover_dialog.vue?vue&type=script&lang=js"
export * from "./recover_dialog.vue?vue&type=script&lang=js"
import style0 from "./recover_dialog.vue?vue&type=style&index=0&id=2205c272&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2205c272",
  null
  
)

export default component.exports